import {LocalColumnDefinition, LocalColumnDefinitionsAsArray, SortPredicates} from "mars-modules";

export const COLUMNS = {
  legalName: new LocalColumnDefinition(
    'legalName',
    SortPredicates.Natural(item => item.legalName)
  ),
  salesHubContractNumber: new LocalColumnDefinition(
    'salesHubContractNumber',
    SortPredicates.Natural(item => item.salesHubContractNumber)
  ),
  ipContractId: new LocalColumnDefinition(
    'ipContractId',
    SortPredicates.Natural(item => item.ipContractId)
  ),
  opportunityName: new LocalColumnDefinition(
    'opportunityName',
    SortPredicates.Natural(item => item.opportunityName)
  ),
  contactName: new LocalColumnDefinition(
    'contactName',
    SortPredicates.Natural(item => item.contactName)
  ),
  status: new LocalColumnDefinition(
    'status',
    SortPredicates.Natural(item => item.status)
  ),
  primaryAuctionEvent: new LocalColumnDefinition(
    'primaryAuctionEvent',
    SortPredicates.Natural(item => item.primaryAuctionEvent)
  ),
  packageCreateDt: new LocalColumnDefinition(
    'packageCreateDt',
    SortPredicates.Natural(item => item.packageCreateDt)
  ),
  oppTmOwner: new LocalColumnDefinition(
    'oppTmOwner',
    SortPredicates.Natural(item => item.oppTmOwner)
  ),
  assetCount: new LocalColumnDefinition(
    'assetCount',
    SortPredicates.Natural(item => item.assetCount)
  ),
  select: new LocalColumnDefinition(
    'select',
    SortPredicates.Natural(item => item.select)
  ),
};

export const COLUMNS_AS_ARRAY = LocalColumnDefinitionsAsArray(COLUMNS);
